


export class BrowserAppEvaluationToolInfo {

  public version = '2024.3.1.1';

  constructor() {
  }

}
